import React from 'react';
import { motion } from 'framer-motion';
import { ThermometerIcon } from 'lucide-react';
export function MechanismSection() {
  return <section className="py-24 px-4 md:px-8 bg-nightBlueLighter relative overflow-hidden" data-id="element-86">
      {/* Decorative background element */}
      <div className="absolute -right-40 top-20 w-96 h-96 bg-teal/5 rounded-full blur-[100px] pointer-events-none" data-id="element-87" />

      <div className="max-w-4xl mx-auto relative z-10" data-id="element-88">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="flex flex-col md:flex-row items-center gap-12" data-id="element-89">
          <div className="flex-1" data-id="element-90">
            <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-teal/10 text-teal font-montserrat font-semibold text-sm mb-6 border border-teal/20" data-id="element-91">
              <ThermometerIcon className="w-4 h-4" data-id="element-92" />
              <span data-id="element-93">El Secreto Biológico</span>
            </div>

            <h2 className="font-playfair font-bold text-3xl md:text-4xl text-warmWhite mb-6" data-id="element-94">
              El Sistema de Sincronización Biológica
            </h2>

            <div className="space-y-6 font-lato text-lg md:text-xl text-warmWhite/90 leading-relaxed" data-id="element-95">
              <p data-id="element-96">
                No es un catálogo de remedios. Es un método basado en el{' '}
                <strong className="text-teal" data-id="element-97">
                  Reset Térmico y Bioquímico
                </strong>
                .
              </p>
              <p data-id="element-98">
                En lugar de forzar el sueño desde afuera con químicos, le
                enviamos las señales correctas a tu Reloj Maestro a través de la
                temperatura interna y la ventana de alimentación.
              </p>
              <p className="p-6 bg-nightBlue rounded-xl border-l-4 border-teal text-warmWhite" data-id="element-99">
                Cuando tu cerebro siente que tu temperatura corporal baja
                exactamente 1.2°C, el sueño profundo se activa de forma
                automática e inevitable.{' '}
                <strong className="text-teal" data-id="element-100">
                  Es biología, no fuerza de voluntad.
                </strong>
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}